module.exports = __webpack_public_path__ + "img/placeholders/salade-cesar.jpg";